import { Colors } from '@ab-core/colors';
import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const NotExistingContainer = styled.div`
    display: flex;
    gap: ${SPACING.SMALL};
    align-items: center;
`;

export const NotExistingStroke = styled.div`
    width: 20px;
    height: 1px;
    background: ${Colors.gray30};
`;
